import React from 'react';
import styles from './Stepper.module.css';

const TOTAL_STEPS = 3;

const CheckmarkIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8L5.5 11.5L13 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const OnboardingStepper = ({ activeStep }) => {
  const elements = [];

  for (let i = 0; i < TOTAL_STEPS; i++) {
    if (i > 0) {
      const connectorClass = i <= activeStep ? styles.connectorDone : styles.connectorPending;
      elements.push(
        <div key={`c-${i}`} className={`${styles.connector} ${connectorClass}`} />
      );
    }

    if (i < activeStep) {
      elements.push(
        <div key={`s-${i}`} className={`${styles.stepCircle} ${styles.stepCircleDone}`}>
          <CheckmarkIcon />
        </div>
      );
    } else if (i === activeStep) {
      elements.push(
        <div key={`s-${i}`} className={`${styles.stepCircle} ${styles.stepCircleActive}`}>
          <span className={styles.stepCircleActiveDot} />
        </div>
      );
    } else if (i === TOTAL_STEPS - 1) {
      elements.push(
        <div key={`s-${i}`} className={`${styles.stepCircle} ${styles.stepCirclePendingLast}`} />
      );
    } else {
      elements.push(
        <div key={`s-${i}`} className={`${styles.stepCircle} ${styles.stepCirclePending}`}>
          <span className={styles.stepCirclePendingDot} />
        </div>
      );
    }
  }

  return <div className={styles.stepper}>{elements}</div>;
};

export default OnboardingStepper;
